export default class GlobalVars{
	static Pastorais = {
		"Apostolado da Oração":{
			title: "Apostolado da Oração",
			text: '“O Apostolado da Oração é um caminho espiritual que a Igreja '+
			'propõe a todos os cristãos para os ajudar a ser amigos e apóstolos de Jesus '+
			'Ressuscitado na vida diária, apaixonados por Ele e interiormente disponíveis '+
			'para a sua missão. Apresenta-se visivelmente como uma rede mundial de oração ao '+
			'serviço dos desafios da humanidade e da missão da Igreja, expressos nas intenções mensais de '+
			'oração do Papa.” – Fonte: Apostolado da Oração.',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Comissão de Obras e Reformas":{
			title: "Comissão de Obras e Reformas",
			text: '“Aquele grupo de vicentinos, de elevado espírito comunitário e religioso, '+
			'promoveu um inédito e grandioso movimento de envolvimento dos moradores para conseguir um '+
			'terreno e construir uma igreja na comunidade. O vigário da Paróquia São Paulo da Cruz, à '+
			'época, orientou o Sr. José Geraldo Moreira a instituir uma Comissão de Obras. “Chegamos em '+
			'casa, trocamos a camisa e já não éramos mais a Conferência. Voltamos ao Padre Félix como '+
			'uma Comissão de Obras”, concluiu. Isto aconteceu logo após à fundação da Conferência Santos '+
			'Anjos da Guarda, em 21 de Abril de 1978.” Hoje esta comissão é muito atuante em toda  manutenção da igreja.',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Conferências Divino Espírito Santo, Santos Anjos da Guarda e São Pedro":{
			title: "Conferências Divino Espírito Santo, Santos Anjos da Guarda e São Pedro",
			text: 'Formam, também, uma das bases de direção espiritual em nossa comunidade, '+
			'com fundação datada por volta da década de 1980. ',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Coordenação de Canto":{
			title: "Coordenação de Canto",
			text: 'Responsável pelo diálogo constante e o assumir das ações do canto, '+
			'que se torna duplamente um ato de evangelização, junto aos grupos de canto: Coral '+
			'Sagrado Coração de Jesus (13 membros), Grupo de Canto São Pedro (08 membros) e o '+
			'Ministério Kairós (14 membros). Ambos os grupos têm suas histórias enraizadas na '+
			'estruturação das pastorais e movimentos que foram surgindo ao final dos anos 70 (setenta) na '+
			'comunidade, sendo o Ministério Kairós o mais novo, hoje com 01 (um) ano.',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Equipe de Áudio e Vídeo":{
			title: "Equipe de Áudio e Vídeo",
			text: 'Fundada em 1996 logo após a instalação do som que fora adquirido à comunidade.'+
			' Desempenha relevante papel junto à Pastoral da Comunicação, através dos serviços de'+
			' sonorização, retro projeção e vídeo. ',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Equipe de Cerimonial":{
			title:"Equipe de Cerimonial",
			text: 'Responsável por dar maior apoio e melhor cuidar'+
			' de todos os momentos que ditam sobre o sacramento do matrimônio, '+
			'eventos que é realizado na comunidade, desde sua criação em fevereiro de 2009. ',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Equipe de Eventos":{
			title:"Equipe de Eventos",
			text: 'Sugestivo bem como o nome, equipe composta que se responsabilizam'+
			' pela atuação nos mais diversos eventos realizados pela comunidade,'+
			' enriquecendo tradições, momentos, sobretudo, garantindo prestígio aos nossos'+
			' irmãos em momentos de grande partilha e felicidade. ',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Pastoral Catequética":{
			title:"Pastoral Catequética",
			text: 'Torna-se, portanto, uma “Equipe” por englobar tantas outras pastorais que assumem'+
			' o papel do fortalecimento da evangelização em nossa comunidade, bem como: a Iniciação'+
			' Cristã de Adultos, Catequese, Pastoral da Crisma, Pastoral da Juventude e a Pastoral do Batismo. ',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Pastoral do Batismo":{
			title:"Pastoral do Batismo",
			text: 'Tem como objetivos, preparar pessoas adultas, principalmente os pais, '+
			'junto com os padrinhos, para que tenham consciência da importância do Sacramento '+
			'do Batismo, como iniciação cristã, pertença à Igreja, identidade católica, na vivência'+
			' da fé eclesial missionária.',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Juventude Acumulada":{
			title:"Juventude Acumulada",
			text: 'Tem como missão a promoção e valorização da Pessoa Idosa,'+
			' dando-lhe a oportunidade para melhorar sua qualidade de vida, '+
			'respeitando seus direitos por um processo educativo integrado a sua '+
			'família e a comunidade. Com a formação de redes comunitárias de líderes'+
			' voluntários que multiplicam o saber e a solidariedade fraterna.',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Ministério da Eucaristia/Palavra":{
			title:"Ministério da Eucaristia/Palavra",
			text: 'A Igreja confia o Ministério Extraordinário da Sagrada Comunhão e faz'+
			' com que ele se constitua a serviço da comunidade, em assembleia liturgia,'+
			' para que se compartilhe a mesa fraternal da Comunhão, na consolação dos enfermos,'+
			' anciãos e impedidos, de modo que se fortaleçam com o Pão da Vida. Em primeiro lugar,'+
			' sabe-se que é um serviço, porém, intimamente, este é descoberto como uma honra. Através'+
			' dos ministros, pelas mãos e palavras, será possível a comum-união dos irmãos a Cristo, no Sacramento do Teu Corpo e Sangue. ',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Pastoral Litúrgica":{
			title:"Pastoral Litúrgica",
			text: 'Para melhor organização, unem-se o Ministério de Leitores,'+
			' Ministério de Coroinhas e Acólitos e, propriamente, a Pastoral Litúrgica. '+
			'Desempenha a ação sagrada, através da qual, com ritos, na Igreja e pela Igreja, se exerce'+
			' e prolonga a obra sacerdotal de Cristo, que tem por objetivos a santificação dos homens e a glorificação de Deus” (SC 7). ',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"PASCOM - Pastoral da Comunicação":{
			title:"PASCOM - Pastoral da Comunicação",
			text: 'Responsável por tornar público todo o trabalho pastoral desenvolvido na comunidade. '+
			'O trabalho que a Pastoral da Comunicação desenvolve engloba a comunicação entre pastorais e '+
			'movimentos e a comunicação destes com a comunidade, de forma a integrar as pastorais, os movimentos,'+
			' os fiéis e o clero, procurando levar todos a anunciarem as mesmas palavras de amor que Jesus nos anunciou.',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Pastoral da Saúde":{
			title:"Pastoral da Saúde",
			text: 'Tem como missão principal levar aos enfermos e idosos da comunidade a'+
			' alegria da presença de Cristo Jesus através da Igreja, nos seus agentes de pastoral.'+
			' Leva a palavra de conforto em hospitais e residências, empenhando-se em despertar a '+
			'consciência dos cristãos para o valor da vida. Esta pastoral conta hoje com 05 (cinco) participantes.',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Pastoral do Dízimo":{
			title:"Pastoral do Dízimo",
			text: 'A Pastoral do Dízimo é a ação eclesial que tem por finalidade motivar, planejar,'+
			' organizar e executar iniciativas para a implantação e o funcionamento do dízimo, e acompanhar '+
			'os membros da comunidade no que diz respeito à sua colaboração, em sintonia com a Pastoral de Conjunto'+ 
			' na Igreja particular.” (Doc. 106, 36)',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Grupo de Adolescentes":{
			title:"Grupo de Adolescentes",
			text: 'Claro objetivo de formação dos adolescentes para que se tornem pessoas mais conscientes'+
			' e críticas diante os valores da sociedade, além de integrá-los à vida litúrgica da comunidade. ',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Renovação Carismática Católica":{
			title:"Renovação Carismática Católica",
			text: 'A RCC é o segundo grande movimento popular da Igreja Católica logo após o Concílio Vaticano II. '+
			'O primeiro grande movimento foi o das Comunidades Eclesiais de Base, ou seja, a criação de comunidades de leigos '+
			'que cultivassem a vida cristã através da oração, da leitura da Bíblia, reflexão e apoio mútuo. A RCC tem uma '+
			'proposta bem diferente e dinâmica, enfatizando a relação com o Sagrado, que se traduz num culto fervoroso, animado '+
			'por cânticos e tantas outras ações. ',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
		"Pastoral da Criança":{
			title:"Pastoral da Criança",
			text: 'A Pastoral da Criança, organismo de ação social da CNBB, alicerça sua atuação na '+
			'organização da comunidade e na capacitação de líderes voluntários que ali vivem e assumem a '+
			'tarefa de orientar e acompanhar as famílias vizinhas em ações básicas de saúde, educação, nutrição '+
			'e cidadania tendo como objetivo o "desenvolvimento integral das crianças, promovendo, em função delas, '+
			'também suas famílias e comunidades, sem distinção de raça, cor, profissão, nacionalidade, sexo, credo religioso ou '+
			'político" (Artigo 2º do Estatuto).',
			img: '',
			cord: '',
			hora: '',
			info: ''
		},
	}

	static books = {
    "genesis": "Gênesis",
    "exodo": "Êxodo",
    "levitico": "Levítico",
    "numeros": "Números",
    "deuteronomio": "Deuteronômio",
    "josue": "Josué",
    "juizes": "Juízes",
    "rute": "Rute",
    "i-samuel": "I Samuel",
    "ii-samuel": "II Samuel",
    "i-reis": "I Reis",
    "ii-reis": "II Reis",
    "i-cronicas": "I Crônicas",
    "ii-cronicas": "II Crônicas",
    "esdras": "Esdras",
    "neemias": "Neemias",
    "tobias": "Tobias",
    "judite": "Judite",
    "ester": "Ester",
    "jo": "Jó",
    "salmos": "Salmos",
    "i-macabeus": "I Macabeus",
    "ii-macabeus": "II Macabeus",
    "proverbios": "Provérbios",
    "eclesiastes": "Eclesiastes",
    "cantico-dos-canticos": "Cântico dos Cânticos",
    "sabedoria": "Sabedoria",
    "eclesiastico": "Eclesiástico",
    "isaias": "Isaías",
    "jeremias": "Jeremias",
    "lamentacoes": "Lamentações",
    "baruc": "Baruc",
    "ezequiel": "Ezequiel",
    "daniel": "Daniel",
    "oseias": "Oséias",
    "joel": "Joel",
    "amos": "Amós",
    "abdias": "Abdias",
    "jonas": "Jonas",
    "miqueias": "Miquéias",
    "naum": "Naum",
    "habacuc": "Habacuc",
    "sofonias": "Sofonias",
    "ageu": "Ageu",
    "zacarias": "Zacarias",
    "malaquias": "Malaquias",
    "sao-mateus": "São Mateus",
    "sao-marcos": "São Marcos",
    "sao-lucas": "São Lucas",
    "sao-joao": "São João",
    "atos-dos-apostolos": "Atos dos Apóstolos",
    "romanos": "Romanos",
    "i-corintios": "I Coríntios",
    "ii-corintios": "II Coríntios",
    "galatas": "Gálatas",
    "efesios": "Efésios",
    "filipenses": "Filipenses",
    "colossenses": "Colossenses",
    "i-tessalonicenses": "I Tessalonicenses",
    "ii-tessalonicenses": "II Tessalonicenses",
    "i-timoteo": "I Timóteo",
    "ii-timoteo": "II Timóteo",
    "tito": "Tito",
    "filemon": "Filêmon",
    "hebreus": "Hebreus",
    "sao-tiago": "São Tiago",
    "i-sao-pedro": "I São Pedro",
    "ii-sao-pedro": "II São Pedro",
    "i-sao-joao": "I São João",
    "ii-sao-joao": "II São João",
    "iii-sao-joao": "III São João",
    "sao-judas": "São Judas",
    "apocalipse": "Apocalipse"
    }

	static livrosarr = [["genesis",50],["exodo",40],["levitico",27],["numeros",36],["deuteronomio",34],
	["josue",24],["juizes",21],["rute",4],["i-samuel",31],["ii-samuel",24],["i-reis",22],["ii-reis",25],
	["i-cronicas",29],["ii-cronicas",36],["esdras",9],["neemias"],["tobias",14],["judite",16],
	['ester',16],['jo',42],['salmos',150],['i-macabeus',16],['ii-macabeus',15],['proverbios',31],
	['eclesiastes',12],['cantico-dos-canticos',8],["sabedoria",19],["eclesiastico",51],["isaias",66],
	["jeremias", 52], ["lamentacoes", 5], ["baruc", 6], ["ezequiel", 48], ["daniel", 12], ["oseias", 14],
	["joel", 3], ["amos", 9], ["abdias", 1], ["jonas", 4], ["miqueias", 7], ["naum", 3], ["habacuc", 3],
	["sofonias", 3], ["ageu", 2], ["zacarias", 14], ["malaquias", 4], ["sao-mateus", 28], ["sao-marcos", 16],
	["sao-lucas", 24], ["sao-joao", 21], ["atos-dos-apostolos", 28], ["romanos", 16], ["i-corintios", 16],
	["ii-corintios", 13], ["galatas", 6], ["efesios", 6], ["filipenses", 4], ["colossenses", 4], ["i-tessalonicenses", 5],
	["ii-tessalonicenses", 3], ["i-timoteo", 6], ["ii-timoteo", 4], ["tito", 3], ["filemon", 1], ["hebreus", 13],
	["sao-tiago", 5], ["i-sao-pedro", 5], ["ii-sao-pedro", 3], ["i-sao-joao", 5], ["ii-sao-joao", 1], ["iii-sao-joao", 1],
	["sao-judas", 1], ["apocalipse", 22]
	]

	static programacao = {
        Semanal: [{
            day: "DOM",
            title: "Missa",
            hour: "08h00"
        },
        {
            day: "DOM",
            title: "Celebração",
            hour: "19h00"
        },
        {
            day: "QUA",
            title: "Terço das Mulheres",
            hour: "15h00"
        },
        {
            day: "QUA",
            title: "Grupo de Oração",
            hour: "19:30"
        },
        {
            day: "QUI",
            title: "Adoração ao Santíssimo",
            hour: "05h00"
        },
        {
            day: "QUI",
            title: "Terço dos Homens",
            hour: "19h30"
        }
    	],
		Mensal: [
			{
				day: "Todo dia 29",
				title: "Adoração ao Santíssimo",
				hour: "18h30"
			},
			{
				day: "Todo dia 29",
				title: "Celebração Votiva",
				hour: "19h30"
			}
		]
	}

}